// A function that removes All HTML tags, as well as unescaped HTML entities
export default function sanitizeHtml(html: string): string {
  // Remove HTML tags
  html = html.replace(/<[^>]*>/g, '');
  // Remove unescaped HTML entities
  //html = html.replace(/&[^;]+;/g, '');

  return html;
}
